import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";



@Component({
  selector: "chip-panel",
  templateUrl: "./chip-panel.component.html",
  styleUrls: ["./chip-panel.component.scss"]
})
export class ChipPanelComponent implements OnInit {

  @Input('items')
  set items(value:any[]){
    this._items = value;
  }
  
  _items: any[];

  @Input()
  selectType: string;

  @Input()
  defaultIcon: string;

  @Input()
  translation: string;

  @Input()
  required: boolean;

  keyword:string;

  @Output() clicked = new EventEmitter<any>();


  constructor() {
  }

  ngOnInit(): void {}

  onClick(itemClicked){
    if(this.selectType == 'multi'){
      itemClicked.selected = !itemClicked.selected; 
    }
    else {
      for(const item of this._items){
        if(item.label !== itemClicked.label){
          item.selected = false;
        }
        else{
          item.selected = !item.selected;
        }
      }
    }
    this.clicked.emit(itemClicked);
  }
}
